import { createFlagOverridesFromMap, OverrideBehaviour, type FlagOverrides } from "configcat-react";

export const Flags = {
    OnaAIEnabled: "onaAIEnabled",
    OnaEnvironmentOnboardingEnabled: "isOnaEnvironmentOnboardingEnabled",
    InsightsDisabled: "isInsightsDisabled",

    IsGcpRunnerEnabled: "is_gcp_runner_enabled",
    GlobalOverload: "global_overload",
    EnableAgentFollowMode: "enable_agent_follow_mode",
    IsSentryEnabled: "is_frontend_dash_sentry_enabled",
    WorkflowsEnabled: "workflows_enabled",
    IsMobileVscodeEnabled: "is_mobile_vscode_enabled",
    UseReleasesProxy: "use_releases_proxy",
    SpecModeEnabled: "spec_mode_enabled",
    EnableFailedPaymentReconciler: "enableFailedPaymentReconciler",

    OnaIntelligenceConsumptionUIEnabled: "ona_intelligence_consumption_ui_enabled",
    AutomationsRepoListModeEnabled: "automations_repo_list_mode_enabled",
    AutomationsWebhooksAllowed: "automations_webhooks_allowed",

    ReviewCommentsEnabled: "review_comments_enabled",
    OrgRolesEnabled: "org_roles_enabled",
    ShareableOnaLinksEnabled: "shareable_ona_links_enabled",
    SCIMEnabled: "scim_enabled",
    AgentImageAttachmentsEnabled: "agent_image_attachments_enabled",
    DevRunnerRegistrationEnabled: "dev_runner_registration_enabled",

    SSOAdditionalScopesEnabled: "sso_additional_scopes_enabled",
    VetoExecutions: "veto_executions",
    DashboardUpdatedNudgeEnabled: "dashboardUpdatedNudgeEnabled",
    AutoTopupEnabled: "auto_topup_enabled",
    RunnerSideAgentEnabled: "runner_side_agent_enabled",
    EnterpriseCreditUsageEnabled: "enterprise_credit_usage_enabled",
    MaxLifetimeEnforcementEnabled: "max_lifetime_enforcement_enabled",
    PermissionDataloaderEnabled: "permission_dataloader_enabled",
    SuperOnaEnabled: "super_ona_enabled",
    ExportCsvButtonEnabled: "export_csv_button_enabled",

    // Experiment flags — evaluated via custom attributes, not localStorage overrides.
    // Listed here so the ConfigCat proxy serves them.
    ExperimentRalph: "experiment_ralph",
};

export function getLocalStorageKey(flag: string): string {
    return `feature_flag_${flag}`;
}

/**
 * Flags prefixed with `experiment_` are evaluated via custom attributes
 * passed to ConfigCat, not via localStorage overrides.
 */
function isExperimentFlag(flagKey: string): boolean {
    return flagKey.startsWith("experiment_");
}

export function localFlagOverrides(): FlagOverrides {
    const overrides: Record<string, boolean | number> = {};

    for (const flagKey of Object.values(Flags)) {
        // Experiment flags use custom attributes for evaluation, not local overrides
        if (isExperimentFlag(flagKey)) {
            continue;
        }

        const storageKey = getLocalStorageKey(flagKey);
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedValue = JSON.parse(storedValue);
                if (typeof parsedValue === "boolean" || typeof parsedValue === "number") {
                    console.debug(`Local flag override from localStorage: ${flagKey} = ${parsedValue}`);
                    overrides[flagKey] = parsedValue;
                }
            } catch (e) {
                console.warn(`Failed to parse localStorage value for flag ${flagKey}`, e);
            }
        }
    }

    return createFlagOverridesFromMap(overrides, OverrideBehaviour.LocalOverRemote);
}
